import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Translate } from '@/components';
import styles from './LocationList.styles';

interface LocationListProps {
  locations: Array<string>;
}

const LocationList: React.FC<LocationListProps> = ({ locations }) => {
  return (
    <div className={styles.container}>
      {locations.map(location => (
        <div className={styles.card} key={location}>
          {location === 'Locally Operated' ? (
            <SupportAgentIcon />
          ) : (
            <CorporateFareOutlinedIcon />
          )}

          <span className={styles.text}>
            <Translate>{location}</Translate>
          </span>
        </div>
      ))}
    </div>
  );
};

export default LocationList;
